
<template>
  <!--新增应用-->
  <x-addEdit
    ref="addEdit"
    @updateReqData="reqData=$event"
    :formList="formList"
    :formKey="formKey"
    :formData="formData"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect, mixin.addEdit],
  name: 'addApplication',
  data () {
    let decoratorOptions = {
      title: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入应用名称'},
          {min: 2, max: 20, message: '功能名为2-20个字'}
        ]
      },
      unique_mark: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入功能识别符'},
          {min: 2, max: 20, message: '功能识别符为2-20个字'}
        ]
      },
      icon: {
        rules: [{required: true, message: '请上传图标'}]
      },
      platform: {
        rules: [{required: true, message: '请选择平台'}]
      },
      sort: {rules: []},
      is_default: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{required: true, message: '请选择是否默认'}]
      },
      price: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '请输入价格'}]
      },
      scope_type: {
        rules: [{required: true, message: '请选择应用范围'}]
      },
      description: {rules: [{min: 2, max: 20, message: '描述信息为2-20个字'}]}
    };
    return {
      reqData: '',
      appTypeObj: {
        addCommunityApp: { app_type: 2 },
        addStewardApp: { app_type: 1 }
      },
      formData: '',
      formKey: {
        title: '',
        unique_mark: '',
        icon: '',
        platform: '',
        sort: '',
        is_default: '',
        price: '',
        scope_type: '',
        android: '',
        ios: '',
        scope: '',
        city_scope: '',
        community_scope: '',
        description: ''
      },
      formList: [
        {
          label: '应用名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入应用名称',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '识别符',
          inputType: 'input',
          options: [],
          placeholder: '请输入识别符',
          props: ['unique_mark', decoratorOptions.unique_mark]
        },
        {
          label: '图标',
          inputType: 'upload',
          options: [],
          placeholder: '',
          name: 'icon',
          resUrl: 'icon_url',
          resName: 'file_name',
          fileList: [],
          uploadParam: {
            action: this.$store.state.uploadUrl,
            accept: this.$store.state.imgAccep,
            listType: 'picture'
          },
          props: ['icon', decoratorOptions.icon]
        },
        {
          label: '平台',
          inputType: 'checkboxGroup',
          options: [],
          placeholder: '',
          props: ['platform', decoratorOptions.platform]
        },
        {
          label: '排序',
          inputType: 'input',
          options: [],
          placeholder: '请输入排序',
          type: 'number',
          extra: '默认排序：99',
          props: ['sort', decoratorOptions.sort]
        },
        {
          label: '是否默认',
          inputType: 'switch',
          options: [],
          placeholder: '请选择是否默认',
          props: ['is_default', decoratorOptions.is_default]
        },
        {
          label: '价格',
          inputType: 'input',
          options: [],
          placeholder: '请输入价格',
          props: ['price', decoratorOptions.price]
        },
        {
          label: '应用范围',
          inputType: 'select',
          options: this.$store.state.userRange,
          handle: this.handleUserRange,
          placeholder: '请选择应用范围',
          props: ['scope_type', decoratorOptions.scope_type]
        },
        {
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: true,
          key: 'city',
          props: ['city_scope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          label: '选择小区',
          inputType: 'transfer',
          options: [],
          placeholder: '',
          titles: ['小区列表', '已选'],
          key: 'community',
          props: ['community_scope', {
            rules: [{required: true, message: '请选择小区'}]
          }]
        },
        {
          label: '应用描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述',
          props: ['description', decoratorOptions.description]
        }
      ],
      addParam: {
        url: '/application',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/application/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/application/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.typeSelect({ index: 3, query: 'push_aims_type_desc' });
      this.userRangeList(8, 9);
    },
    /* 处理用户范围 */
    handleUserRange (val, formVals) {
      let userTypeObj = {
        0: { city: false, community: false },
        1: { city: true, community: false },
        2: { city: false, community: true }
      };
      this.handleDynamicForm(val, userTypeObj);
      formVals && (this.formData = formVals);

      if (formVals) {
        this.$nextTick(() => {
          if (formVals.scope_type === 2) {
            this.$refs.addEdit.targetKeys = formVals.scope;
          }
          this.$refs.addEdit.form.setFieldsValue(formVals);
        });
      }
    },
    reqHandle (param) {
      param = {...param, ...this.appTypeObj[this.$route.name]};
      param.is_default = param.is_default === true ? 1 : 0;

      let platform = param.platform;
      if (platform.length) {
        platform.forEach((el) => {
          el === 1 && (param.ios = 1);
          el === 2 && (param.android = 1);
        });
        if (!param.hasOwnProperty('ios')) {
          param.ios = 0;
        }
        if (!param.hasOwnProperty('android')) {
          param.android = 0;
        }
      } else {
        param.android = 0;
        param.ios = 0;
      }

      param = this.rangeReqVal(param);
      console.log('reqHandle: ', param);
      return param;
    },
    detailResHandle (res) {
      let value = {};
      for (let item in res) {
        if (this.formKey.hasOwnProperty(item)) {
          value[item] = res[item];
        }
      }
      res.is_default === 1 ? value.is_default = true : value.is_default = false;
      let arr = [];
      res.android && arr.push(2); // ios: 1, android: 2
      res.ios && arr.push(1);
      value.platform = arr;
      if (res.scope) {
        value.scope = res.scope.split(',');
        value = this.rangeResVal(value, res);
      }
      this.handleUserRange(res.scope_type, value);
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/package/pageCompo/addApplication.vue